import { NgModule } from '@angular/core';
import { Routes, RouterModule, PreloadAllModules } from '@angular/router';

import { QuestionListComponent } from './question-list/question-list.component';
import { HomeComponent } from './core/home/home.component';
import { TutorialComponent } from './core/tutorial/tutorial.component';
import { ReportComponent } from './report/report.component';
import { AuthGuard } from './auth/auth-guard.service';

const appRoutes: Routes = [
  { path: '', component: HomeComponent },
  { path: 'tutorial', component: TutorialComponent },
  { path: 'report', component: ReportComponent },
  { path: 'events', loadChildren: './events/events.module#EventsModule'},
  { path: 'question-list', component: QuestionListComponent, canActivate: [AuthGuard]}
];

@NgModule({
  imports: [
    RouterModule.forRoot(appRoutes, {preloadingStrategy: PreloadAllModules})
  ],
  exports: [RouterModule]
  , providers: [
    AuthGuard
  ]
})
export class AppRoutingModule {

}



// WEBPACK FOOTER //
// ./src/app/app-routing.module.ts